import { render, staticRenderFns } from "./ProductDescription.vue?vue&type=template&id=47d5bc83&scoped=true"
import script from "./ProductDescription.vue?vue&type=script&lang=ts"
export * from "./ProductDescription.vue?vue&type=script&lang=ts"
import style0 from "./ProductDescription.vue?vue&type=style&index=0&id=47d5bc83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d5bc83",
  null
  
)

export default component.exports